import { render, staticRenderFns } from "./RiwayatEditKap.vue?vue&type=template&id=7c69f9e8&"
import script from "./RiwayatEditKap.vue?vue&type=script&lang=js&"
export * from "./RiwayatEditKap.vue?vue&type=script&lang=js&"
import style0 from "./RiwayatEditKap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports